export default {
    "created": "Oferta a fost creata cu succes",
    "updated": "Oferta a fost actualizata cu succes",
    "deleted": "Oferta a fost ștearsa cu succes",
    "restored": "Oferta a fost restaurata cu succes",
    'title': 'Ofertele noastre',
    'subtitle': 'Descoperă',
    'all_seasons': 'Toate',
    'all_offers': 'Toate ofertele',
    'details': 'Mai multe detalii',
    'no_offers': 'Momentan nu exista oferte disponibile',
    'write_whatsapp': 'Scrie-ne pe WhatsApp',
}
